import React, { useEffect, useState } from "react";
import { IDocumentFields } from "../../interfaces/ICase";
import { IUploadReferral } from "../../interfaces/IReferral";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  deleteUploadedDocument,
  downloadDocument,
} from "../../apis/patientService";
import {
  clearOcrDetails,
  clearOcrDetailsOfReferral,
  clearPatientDetails,
  clearPatientReferrals,
  clearUhiNo,
  fetchPatientDetailsByBeneficiaryId,
  //   fetchPatientDetailsFromAyushBPortal,
  fetchPatientDetailsFromPortal,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
  getPatientDetailsUsingUHID,
  postBeneficiaryDetailsForScheme,
  postPatientDetails,
  readOcrDocs,
  swapReadOcrDetails,
  uploadDocument,
} from "../../models/patientSlice";
import "../../components/patient/modern-styles.css";
import "./addPatientContainer-responsive.css";
import {
  addPatientScheme,
  clearSelectedScheme,
  fetchAllSchemesOnBoard,
  selectedScheme,
} from "../../models/schemeSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { errorMessage, successMessage } from "../../utils/notificationUtils";
import {
  IPatient,
  IPostBeneficiaryDetails,
  ReferralUpload,
} from "../../interfaces/IPatient";
import { calculateAge } from "../../utils/globalUtils";
import {
  getReferralById,
  resetUpdateReferral,
} from "../../models/referralSlice";
import { getDocuments } from "../../apis/schemeService";
import dayjs from "dayjs";
import { IDoctorsState } from "../../interfaces/IDoctor";
import { getDoctors, resetAvailableDoctors } from "../../models/doctorSlice";
import { getCaseTypes } from "../../models/casesSlice";
import { Divider, Flex, message, Tabs } from "antd";
// import "./addPatientContainer.css";
import { ISchemeOnBoard } from "../../interfaces/IScheme";
import { Select } from "antd";
import IndexLetterModal from "../../components/patient/IndexLetterModal";
import { Form } from "antd";
import { Col } from "antd";
import { Row } from "antd";
import RegistrationSlipModal from "../../components/patient/RegistrationSlipModal";
import AddPatientForm from "../../components/patient/AddPatientForm";
import Title from "antd/es/typography/Title";
import RejectionModal from "../../modals/RejectionModal";
import { saveDraftEchs } from "../../apis/SchemeService/ECHS/echsService";
import { registerPatientPortalCghsNew } from "../../apis/SchemeService/CGHS/cghsService";
import { Radio } from "antd";
import AddNewPatientForm from "../../components/patient/AddNewPatientForm";
import { Spin } from "antd";

const { Option } = Select;
const AddPatientContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [secondaryMobileOnWhatsApp, setSecondaryMobileOnWhatsApp] =
    useState<boolean>(false);
  const [primaryMobileOnWhatsApp, setPrimaryMobileOnWhatsApp] =
    useState<boolean>(true);
  const [isReferralUploaded, setIsReferralUploaded] = useState<boolean>(false);
  const [showCompareModal, setShowCompareModal] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false); // to check whether user has clicked on confirmation modal
  const { auth, patients, scheme, hospital, doctor, cases, referral } =
    useSelector((state: RootState) => state);
  const [documentTypes, setDocumentTypes] = useState<{
    [key: string]: Array<{ label: string; value: string }>;
  }>({});
  const [isFetchingDocuments, setIsFetchingDocuments] = useState<boolean>(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentType, setDocumentType] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [showServices, setShowServices] = useState<boolean>(true);
  const [selectedReferralId, setSelectedReferralId] = useState<number | null>(
    null,
  );
  const [selectedCaseTypeName, setSelectedCaseTypeName] = useState<any>("");
  const handleShowServices = () => {
    // setShowServices(!showServices);
    setShowServices(true);
  };
  const navigate = useNavigate();
  const [listOfResponseUrl, setlistOfResponseUrl] =
    useState<Array<IDocumentFields> | null>(null);
  const [listOfUploadDocData, setListOfUploadDocData] = useState<
    Array<IDocumentFields>
  >([]);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [doctorOptions, setDoctorOptions] = useState<IDoctorsState[]>([]);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<any>();
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null,
  ); //to send document id for deficiency check
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");
    const [polyclinicList, setPolyclinicList] = useState<any[]>([]);

  const [open, setOpen] = useState<boolean>(false); //to open confirmation Modal
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //to check whether confirmation modal is open or not

  const [indexCardModal, setIndexCardModal] = useState<boolean>(false); //to check whether index card modal is open or not
  const [indexCardSavedPatient, setIndexCardSavedPatient] = useState<any>(null); //to save patient details from index card modal
  const [indexCardPatients, setIndexCardPatients] = useState<any>([]); //to save patients from index card modal
  const [indexCardCategory, setIndexCardCategory] = useState<any>(null);

  const [registrationSlipModal, setRegistrationSlipModal] =
    useState<boolean>(false); //to check whether registration slip modal is open or not
  const [registrationSlipSavedPatient, setRegistrationSlipSavedPatient] =
    useState<any>(null); //to save patient details from registration slip modal
  const [registrationSlipPatients, setRegistrationSlipPatients] = useState<any>(
    [],
  ); //to save patients from registration slip modal
  const [registrationSlipCategory, setRegistrationSlipCategory] =
    useState<any>(null);

  const [submittedPatientDetails, setSubmittedPatientDetails] =
    useState<any>(null);
  const [showPatientFields, setShowPatientFields] = useState<boolean>(false);
  const [isConfirmCardModal, setIsConfirmCardModal] = useState<boolean>(false);
  const [actualReferralList, setActualReferralList] =
    useState<any>(Object.values(patients?.referrals)) || [];
  const [actualCardList, setActualCardList] = useState<any>([]);
  const [actualIndexCardList, setActualIndexCardList] = useState<any>([]);
  const [actualRegnSlipList, setActualRegnSlipList] = useState<any>([]);
  const [isSchemeSelected, setIsSchemeSelected] = useState<boolean>(false);
  const [newDocumentTypes, setNewDocumentTypes] = useState<
    { label: string; value: string }[] | undefined
  >([]);
  const [capfreferal, setCapfReferral] =
    useState<Array<IDocumentFields> | null>(null);

  const [showTPADropdown, setShowTPADropdown] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("");
  const [cardInfo, setCardInfo] = useState<any>({});
  const [referralInfo, setReferralInfo] = useState<any>({});
  const { Option } = Select;

  const [isVerifyPatientModal, setIsVerifyPatientModal] =
    useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (patients?.referrals) {
      setActualReferralList(Object?.values(patients?.referrals));
    }
  }, [patients?.referrals]);

  useEffect(() => {
    if (indexCardPatients?.length > 0) {
      setIndexCardModal(true);
    }
  }, [indexCardPatients]);

  useEffect(() => {
    if (registrationSlipPatients?.length > 0) {
      setRegistrationSlipModal(true);
    }
  }, [registrationSlipPatients]);

  useEffect(() => {
    if (
      patients?.documentDetails?.documentLabelType
        ?.toLowerCase()
        ?.includes("index card")
    ) {
      setActualIndexCardList([
        ...actualIndexCardList,
        {
          documentLabelType: patients?.documentDetails?.documentLabelType,
          documentName: patients?.documentDetails?.documentName,
          documentType: patients?.documentDetails?.documentType,
          documentUrl: patients?.documentDetails?.documentUrl,
          id: patients?.documentDetails?.id,
          referenceType: patients?.documentDetails?.referenceType,
        },
      ]);

      setIndexCardPatients(patients?.documentDetails?.indexData || []);
      setIndexCardCategory(patients?.documentDetails?.indexCardCategory);
    } else if (
      patients?.documentDetails?.documentLabelType
        ?.toLowerCase()
        ?.includes("regn slip")
    ) {
      setActualRegnSlipList([
        ...actualRegnSlipList,
        {
          documentLabelType: patients?.documentDetails?.documentLabelType,
          documentName: patients?.documentDetails?.documentName,
          documentType: patients?.documentDetails?.documentType,
          documentUrl: patients?.documentDetails?.documentUrl,
          id: patients?.documentDetails?.id,
          referenceType: patients?.documentDetails?.referenceType,
        },
      ]);

      setRegistrationSlipPatients(patients?.documentDetails?.indexData || []);
      setRegistrationSlipCategory(patients?.documentDetails?.indexCardCategory);
    } else if (
      patients?.documentDetails?.documentLabelType
        ?.toLowerCase()
        ?.includes("card")
    ) {
      setActualCardList([
        ...actualCardList,
        {
          documentLabelType: patients?.documentDetails?.documentLabelType,
          documentName: patients?.documentDetails?.documentName,
          documentType: patients?.documentDetails?.documentType,
          documentUrl: patients?.documentDetails?.documentUrl,
          id: patients?.documentDetails?.id,
          referenceType: patients?.documentDetails?.referenceType,
        },
      ]);
    }
  }, [patients?.documentDetails]);

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (
    e: any,
  ) => {
    const maxSize = 15 * 1024 * 1024;
    if (Array.isArray(e)) {
      return e;
    }
    // if (
    //   scheme?.selectedScheme?.toLocaleUpperCase().includes("ECHS") &&
    //   e?.fileList[0]?.type !== "application/pdf"
    // ) {
    //   errorMessage("File Must be PDF only");
    //   return;
    // }
    // if (e?.file?.size > maxSize) {
    //   errorMessage("File Limit must be less than or equal to 15 MB");
    //   return;
    // }
    if (e?.fileList[0]) {
      setSelectedFile({ file: e?.fileList[0], documentType });
      setUploadFileModal(true);
      setResetForm(false);
    }

    return e?.fileList;
  };

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };

  const handleSelectChange = (document: string) => {
    setDocumentType(document ? document : "");
  };

  const handleShowConfirmModal = (documentUrl: string) => {
    setShowCompareModal(!showCompareModal);
    setPreviewDocumentUrl(documentUrl);
  };
  const handleShowConfirmModal2 = (documentUrl: string) => {
    // setShowCompareModal(true);
    // setPreviewDocumentUrl(documentUrl);
    window.open(documentUrl, "_blank");
  };
  const [selectedSchemeId, setSelectedSchemeId] = useState<string | null>(null);

  const handleSchemeChange: any = (schemeParam: any) => {
    let scheme = schemeParam?.target?.value;
    let schemeId = scheme?.split("-")[0];
    if (schemeId) {
      setSelectedSchemeId(scheme?.split("-")[0]);
    } else {
      setSelectedSchemeId(null);
    }
    if (scheme?.toLowerCase()?.includes("tpa")) {
      setActiveTab("tpa");
      setShowTPADropdown(true);
      dispatch(selectedScheme(null));
      setActiveKey(scheme);
      return;
    }
    setIsModalOpen(false);
    setActiveTab("");
    dispatch(selectedScheme(scheme));
    setActiveKey(scheme);
    setIsSchemeSelected(true);
    setIsReferralUploaded(false);
    setActualCardList([]);
    setIndexCardSavedPatient(null);
    setRegistrationSlipSavedPatient(null);
    setActualReferralList([]);
    setActualIndexCardList([]);
    setActualRegnSlipList([]);
    setShowPatientFields(false);
    setCapfReferral([]);
    setNewDocumentTypes([]);
    setShowCompareModal(false);

    if (
      !scheme?.toLowerCase()?.includes("govt")
      // !scheme?.toLowerCase()?.includes("cghs") &&
      // !scheme?.toLowerCase()?.includes("capf") &&
      // !scheme?.toLowerCase()?.includes("echs") &&
      // !scheme?.toLowerCase()?.includes("pmjy") &&
      // !scheme?.toLowerCase()?.includes("ayushman bharat")
    ) {
      setActiveTab("tpa");
      const tpaTab = schemeTabs?.tabs?.find(
        (tab: any) => tab?.schemeMetaDataName === "TPA",
      );
      if (tpaTab) {
        setActiveKey(
          tpaTab.schemeMetaDataId +
            "-" +
            tpaTab.schemeMetaDataName +
            "-" +
            tpaTab.schemePersonalIdentifierLabelName +
            "-" +
            tpaTab.portalMetaDataIdsList?.[0] +
            tpaTab?.schemeType,
        );
      }
    }

    // setIdentityNumberLabel(
    //   selectedScheme?.schemePersonalIdentifierLabelName
    // );
  };

  const handleSchemeChange2 = (scheme: string) => {
    setSelectedSchemeId(scheme?.split("-")[0]);
    setIsModalOpen(false);
    setActiveTab("");
    dispatch(selectedScheme(scheme));
    setActiveKey(scheme);
    setIsSchemeSelected(true);
    setIsReferralUploaded(false);
    setActualCardList([]);
    setIndexCardSavedPatient(null);
    setRegistrationSlipSavedPatient(null);
    setActualReferralList([]);
    setActualIndexCardList([]);
    setActualRegnSlipList([]);
    setShowPatientFields(false);
    setCapfReferral([]);
    setNewDocumentTypes([]);
    setShowCompareModal(false);

    if (
      !scheme?.toLowerCase()?.includes("govt")
      // !scheme?.toLowerCase()?.includes("cghs") &&
      // !scheme?.toLowerCase()?.includes("capf") &&
      // !scheme?.toLowerCase()?.includes("echs") &&
      // !scheme?.toLowerCase()?.includes("pmjy") &&
      // !scheme?.toLowerCase()?.includes("ayushman bharat")
    ) {
      setActiveTab("tpa");
      const tpaTab = schemeTabs?.tabs?.find(
        (tab: any) => tab?.schemeMetaDataName === "TPA",
      );
      if (tpaTab) {
        setActiveKey(
          tpaTab.schemeMetaDataId +
            "-" +
            tpaTab.schemeMetaDataName +
            "-" +
            tpaTab.schemePersonalIdentifierLabelName +
            "-" +
            tpaTab.portalMetaDataIdsList?.[0] +
            tpaTab.schemeType,
        );
      }
    }

    // setIdentityNumberLabel(
    //   selectedScheme?.schemePersonalIdentifierLabelName
    // );
  };

  useEffect(() => {
    setlistOfResponseUrl(null);
    dispatch(resetUpdateReferral());
    dispatch(clearPatientReferrals());
    dispatch(clearOcrDetails());
    dispatch(clearUhiNo());
    dispatch(clearOcrDetailsOfReferral());
    setSelectedCaseTypeName(null);
    // dispatch(selectedScheme(null));
  }, [dispatch, scheme?.selectedScheme]);

  useEffect(() => {
    const portalIdSelectedScheme = scheme?.selectedScheme?.split("-");
    const fetchDocuments = async () => {
      if (portalIdSelectedScheme) {
        try {
          setIsFetchingDocuments(true);
          const documentList = await getDocuments(
            parseInt(
              portalIdSelectedScheme[portalIdSelectedScheme?.length - 2],
            ),
            parseInt(portalIdSelectedScheme[0]),
          );
          setDocumentTypes(documentList);
        } catch (err) {
          errorMessage("Please, Try again after sometime");
        }
        finally {
          setIsFetchingDocuments(false);
        }
      }
    };

    fetchDocuments();
  }, [scheme?.selectedScheme]);

  useEffect(() => {
    setDoctorOptions(doctor?.availableDoctor || []);
  }, [doctor?.availableDoctor]);

  const deleteDOcument = async () => {
    const deleteForm = {
      documentUrl: "",
      status: false,
      id: "",
    };

    // if (deleteDocument?.documentUrl) {
    try {
      await dispatch(deleteUploadedDocument(deleteForm));
      message.info(`Document deleted`);
    } catch (err) {
      console.error(err);
    }

    // }
  };

  // useEffect(() => {
  //   const fetchDeficiencyData = async () => {
  //     try {
  //       if (selectedDocumentId) {
  //         const res = await dispatch(
  //           getDeficiencyQuestions(selectedDocumentId)
  //         );
  //       }
  //       // if(true) {
  //       //   const res = await dispatch(getDeficiencyQuestions(874));
  //       // }
  //     } catch (err) {
  //       errorMessage("Please, Try again after sometime");
  //       setSelectedDocumentId(null);
  //       setSelectedDocument(null);
  //     }
  //   };

  //   if (selectedDocumentId) fetchDeficiencyData();
  //   // if(true) fetchDeficiencyData();
  // }, [selectedDocumentId]);

  useEffect(() => {
    const fetchDeficiencyData = async () => {
      try {
        if (selectedDocument?.id) {
          const res = await dispatch(
            getDeficiencyQuestionData(selectedDocument?.id),
          );
        }
        // if(true) {
        //   const res = await dispatch(getDeficiencyQuestions(874));
        // }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };
    if (selectedDocument?.id) fetchDeficiencyData();
  }, [selectedDocument]);

  useEffect(() => {
    if (patients?.documentDetails?.documentType) {
      const newDocument = {
        documentType: patients?.documentDetails?.documentType,
        documentName: patients?.documentDetails?.documentName,
        documentUrl: patients?.documentDetails?.documentUrl,
        documentLabelType: patients?.documentDetails?.documentLabelType,
        id: patients?.documentDetails?.id,
      };

      setlistOfResponseUrl((prevList) => {
        const existingIndex = prevList
          ? prevList?.findIndex(
              (doc) => doc?.documentType === newDocument?.documentType,
            )
          : -1;

        if (existingIndex !== -1 && prevList) {
          const updatedList = [...prevList];
          updatedList[existingIndex] = newDocument;
          return updatedList;
        } else {
          return prevList ? [...prevList, newDocument] : [newDocument];
        }
      });

      setUploadFileModal(false); // Close modal after update or addition
    }
  }, [patients?.documentDetails]);

  const handleGetPatientFromPortal = async (values: any) => {
    if (scheme.selectedScheme) {
      const formData = {
        ...values,
        hospitalId: hospital?.selectedHospital?.value,
        patientSchemeDetails: {
          schemeMetaDataId: parseInt(scheme.selectedScheme.split("-")[0]),
          identityNumber: values?.identityNumber,
          patientName: values?.patientName,
          portalMetaDataId: parseInt(scheme.selectedScheme.split("-")[3]),
          status: "ACTIVE",
        },
      };
      let resp;
      //   if (scheme?.selectedScheme?.toLowerCase()?.includes("ayushman bharat")) {
      //     const payloadData = {
      //       portalMetaDataId: formData?.patientSchemeDetails?.portalMetaDataId,
      //       beneficiaryId: formData?.identityNumber,
      //     };
      //     resp = await dispatch(
      //       fetchPatientDetailsFromAyushBPortal({
      //         payloadData,
      //         accessToken: auth.accessToken || "",
      //         hospitalId: hospital?.selectedHospital?.value,
      //       }),
      //     );
      //     if (fetchPatientDetailsFromAyushBPortal.fulfilled.match(resp)) {
      //       successMessage("DATA FETCHED SUCCESSFULLY");
      //     } else if (fetchPatientDetailsFromAyushBPortal.rejected.match(resp)) {
      //       if (resp?.error?.message?.includes("User doesn't exist at portal")) {
      //         errorMessage("Portal inactive. Add patient details manually");
      //       } else {
      //         errorMessage("DATA fAILED TO FETCHED");
      //       }
      //       setShowPatientFields(true);
      //     }
      //   } else
      if (
        scheme?.selectedScheme?.toLowerCase()?.includes("cghs new") ||
        scheme?.selectedScheme?.toLowerCase()?.includes("capf new")
      ) {
        const reqPayload: IPostBeneficiaryDetails = {
          schemeId: parseInt(scheme.selectedScheme.split("-")[0]),
          beneficiaryId: formData?.identityNumber || "",
          hospitalId: hospital?.selectedHospital?.value,
        };
        await dispatch(postBeneficiaryDetailsForScheme(reqPayload));

        resp = await dispatch(
          fetchPatientDetailsByBeneficiaryId(formData?.identityNumber),
        );

        if (fetchPatientDetailsByBeneficiaryId.fulfilled.match(resp)) {
          successMessage(
            resp?.payload?.beneficiaryFetchDto?.message ||
              "DATA FETCHED SUCCESSFULLY",
          );
          if (resp?.payload?.status?.toLowerCase() === "pending") {
            let pollCount = 0;
            const pollInterval = 5000;
            const maxPolls = (60 * 1000) / pollInterval;

            const intervalId = setInterval(async () => {
              pollCount++;

              try {
                resp = await dispatch(
                  fetchPatientDetailsByBeneficiaryId(formData?.identityNumber),
                );

                if (fetchPatientDetailsByBeneficiaryId.fulfilled.match(resp)) {
                  const status = resp?.payload?.status;

                  if (
                    status?.toLowerCase() === "completed" ||
                    status?.toLowerCase() === "failed"
                  ) {
                    successMessage("DATA FETCHED SUCCESSFULLY");
                    clearInterval(intervalId);
                  } else if (pollCount >= maxPolls) {
                    errorMessage("DATA fAILED TO FETCHED");
                    clearInterval(intervalId);
                  }
                } else if (
                  fetchPatientDetailsByBeneficiaryId.rejected.match(resp)
                ) {
                  if (pollCount >= maxPolls) {
                    if (
                      resp?.error?.message?.includes(
                        "User doesn't exist at portal",
                      )
                    ) {
                      errorMessage(
                        "Portal inactive. Add patient details manually",
                      );
                    } else {
                      errorMessage("DATA fAILED TO FETCHED");
                    }
                    clearInterval(intervalId);
                  }
                  setShowPatientFields(true);
                }
              } catch (err) {
                console.error(
                  "Error while polling fetchPatientDetailsByBeneficiaryId:",
                  err,
                );
                clearInterval(intervalId);
                errorMessage(
                  "An error occurred while fetching patient details by beneficiaryId.",
                );
              }
            }, pollInterval);

            setTimeout(() => clearInterval(intervalId), 60 * 1000);
          }
        } else if (fetchPatientDetailsByBeneficiaryId.rejected.match(resp)) {
          if (resp?.error?.message?.includes("User doesn't exist at portal")) {
            errorMessage("Portal inactive. Add patient details manually");
          } else {
            errorMessage("DATA fAILED TO FETCHED");
          }
          setShowPatientFields(true);
        }
      } else {
        resp = await dispatch(
          fetchPatientDetailsFromPortal({
            formData,
            accessToken: auth.accessToken || "",
          }),
        );
        if (fetchPatientDetailsFromPortal.fulfilled.match(resp)) {
          successMessage("DATA FETCHED SUCCESSFULLY");
        } else if (fetchPatientDetailsFromPortal.rejected.match(resp)) {
          if (resp?.error?.message?.includes("User doesn't exist at portal")) {
            errorMessage("Portal inactive. Add patient details manually");
          } else {
            errorMessage("DATA fAILED TO FETCHED");
          }
          setShowPatientFields(true);
        }
      }
    }
  };

  const [selectedReferral, setSelectedReferral] =
    useState<ReferralUpload | null>(null);

  const handleSaveReferral = async (formData: any) => {
    //to submit referral for reading
    const portalIdSelectedScheme = scheme?.selectedScheme?.split("-");
    const CollectPostData = new FormData();
    if (hospital?.selectedHospital) {
      CollectPostData.append(
        "hospitalId",
        hospital?.selectedHospital?.value?.toString(),
      );
    }
    CollectPostData.append("patientId", "");
    CollectPostData.append("caseId", "");
    CollectPostData.append("documentType", formData?.documentType);
    if (formData.file) {
      CollectPostData.append("file", formData?.file);
    }
    if (portalIdSelectedScheme) {
      CollectPostData.append(
        "portalMetaDataId",
        portalIdSelectedScheme[portalIdSelectedScheme?.length - 2],
      );
    }

    const resp = await dispatch(
      readOcrDocs({
        formData: CollectPostData,
        accessToken: auth.accessToken || "",
      }),
    );

    if (readOcrDocs.fulfilled.match(resp)) {
      if (resp?.payload?.errorMessage) {
        errorMessage(resp?.payload?.errorMessage?.message);
        setUploadFileModal(!uploadFileModal);
      } else if (resp?.payload?.[0]?.error) {
        errorMessage(resp?.payload?.[0]?.error);
        setUploadFileModal(!uploadFileModal);
      } else {
        if (
          resp?.payload?.documentLabelType?.toLowerCase()?.includes("referral")
        ) {
          setActualReferralList((prevState: any) => {
            return [
              ...prevState,
              {
                documentType: resp?.payload?.documentType,
                documentName: resp?.payload?.documentName,
                documentUrl: resp?.payload?.documentPath,
                documentLabelType: resp?.payload?.documentLabelType,
                id: resp?.payload?.documentId,
              },
            ];
          });
          setListOfUploadDocData((prevState: any) => {
            return [
              ...prevState,
              {
                documentType: resp?.payload?.documentType,
                documentName: resp?.payload?.documentName,
                documentUrl: resp?.payload?.documentPath,
                documentLabelType: resp?.payload?.documentLabelType,
                id: resp?.payload?.documentId,
              },
            ];
          });
          setSelectedReferral({
            documentType: resp?.payload?.documentType,
            documentName: resp?.payload?.documentName,
            documentUrl: resp?.payload?.documentPath,
            documentLabelType: resp?.payload?.documentLabelType,
            id: resp?.payload?.documentId,
          });

          setReferralInfo(resp?.payload);
          if (cardInfo && Object.keys(cardInfo).length > 0) {
            const cardNoToCompare = scheme?.selectedScheme
              ?.toLowerCase()
              ?.includes("echs")
              ? cardInfo?.cardNo?.replace(/\D/g, "")?.slice(-12)
              : cardInfo?.cardNo;
            if (
              scheme?.selectedScheme?.toLowerCase()?.includes("cghs") &&
              cardNoToCompare?.trim().toUpperCase() !==
                resp?.payload?.beneficiaryId?.trim().toUpperCase()
              // && String(cardInfo?.age) !== String(resp?.payload?.age)
            ) {
              setIsVerifyPatientModal(true);
              // errorMessage(
              //   "Name from Referral and Card is not matching. Please verify."
              // );
            } else if (
              scheme?.selectedScheme?.toLowerCase()?.includes("echs") &&
              cardNoToCompare?.trim().toUpperCase() !==
                resp?.payload?.patientAndEsmInformation?.cardNo
                  ?.trim()
                  .toUpperCase()
            ) {
              setIsVerifyPatientModal(true);
              // errorMessage(
              //   "Name from Referral and Card is not matching. Please verify."
              // );
            }
            // else if (String(cardInfo?.age) !== String(resp?.payload?.age)) {
            //   setIsVerifyPatientModal(true);
            //   errorMessage(
            //     "Age from Referral and Card is not matching. Please verify."
            //   );
            // }
            else {
              successMessage("Document added successfully!");
              setIsVerifyPatientModal(false);
            }
          } else {
            successMessage("Document added successfully!");
            setIsVerifyPatientModal(false);
          }
        } else if (
          resp?.payload?.documentLabelType?.toLowerCase()?.includes("card")
        ) {
          // setActualCardList((prevState: any) => {
          //   return [
          //     ...prevState,
          //     {
          //       documentType: resp?.payload?.documentType,
          //       documentName: resp?.payload?.documentName,
          //       documentUrl: resp?.payload?.documentPath,
          //       documentLabelType: resp?.payload?.documentLabelType,
          //       id: resp?.payload?.documentId,
          //     },
          //   ];
          // });
          setListOfUploadDocData((prevState: any) => {
            return [
              ...prevState,
              {
                documentType: resp?.payload?.documentType,
                documentName: resp?.payload?.documentName,
                documentUrl: resp?.payload?.documentPath,
                documentLabelType: resp?.payload?.documentLabelType,
                id: resp?.payload?.documentId,
              },
            ];
          });

          setCardInfo(resp?.payload);
          if (referralInfo && Object.keys(referralInfo).length > 0) {
            const cardNoToCompare = scheme?.selectedScheme
              ?.toLowerCase()
              ?.includes("echs")
              ? resp?.payload?.cardNo?.replace(/\D/g, "")?.slice(-12)
              : resp?.payload?.cardNo;
            if (
              scheme?.selectedScheme?.toLowerCase()?.includes("cghs") &&
              referralInfo?.beneficiaryId?.trim().toUpperCase() !==
                cardNoToCompare?.trim().toUpperCase()
              // && String(referralInfo?.age) !== String(resp?.payload?.age)
            ) {
              setIsVerifyPatientModal(true);
              // errorMessage(
              //   "Name from Referral and Card is not matching. Please verify."
              // );
            } else if (
              scheme?.selectedScheme?.toLowerCase()?.includes("echs") &&
              referralInfo?.patientAndEsmInformation?.cardNo
                ?.trim()
                .toUpperCase() !== cardNoToCompare?.trim().toUpperCase()
            ) {
              console.log("referral", cardNoToCompare, referralInfo);

              setIsVerifyPatientModal(true);
              // errorMessage(
              //   "Name from Referral and Card is not matching. Please verify."
              // );
            }
            // else if (
            //   String(referralInfo?.age) !== String(resp?.payload?.age)
            // ) {
            //   setIsVerifyPatientModal(true);
            //   errorMessage(
            //     "Age from Referral and Card is not matching. Please verify."
            //   );
            // }
            else {
              successMessage("Document added successfully!");
              setIsVerifyPatientModal(false);
            }
          } else {
            successMessage("Document added successfully!");
            setIsVerifyPatientModal(false);
          }
        } else {
          successMessage("Document added successfully!");
          setIsVerifyPatientModal(false);
        }
        setUploadFileModal(!uploadFileModal);
      }
    } else if (readOcrDocs.rejected.match(resp)) {
      errorMessage("Please, Try again after sometime");
      setIsVerifyPatientModal(false);
    }
  };

  useEffect(() => {
    message.destroy();
  }, [location.pathname]);

  const handleUploadCapfReferral = async (formData: any) => {
    //to submit referral for reading
    const portalIdSelectedScheme = scheme?.selectedScheme?.split("-");
    const CollectPostData = new FormData();
    if (hospital?.selectedHospital) {
      CollectPostData.append(
        "hospitalId",
        hospital?.selectedHospital?.value?.toString(),
      );
    }
    CollectPostData.append("patientId", "");
    CollectPostData.append("caseId", "");
    CollectPostData.append("visitId", "");
    CollectPostData.append("documentType", formData?.documentType);
    if (formData.file) {
      CollectPostData.append("file", formData?.file);
    }
    if (portalIdSelectedScheme) {
      CollectPostData.append(
        "portalMetaDataId",
        portalIdSelectedScheme[portalIdSelectedScheme?.length - 2],
      );
    }

    const resp = await dispatch(uploadDocument(CollectPostData));
    if (uploadDocument.fulfilled.match(resp)) {
      if (resp?.payload?.errorMessage) {
        errorMessage(resp?.payload?.errorMessage);
        setUploadFileModal(!uploadFileModal);
      } else if (resp?.payload?.[0]?.error) {
        errorMessage(resp?.payload?.[0]?.error);
        setUploadFileModal(!uploadFileModal);
      } else {
        successMessage("Document added successfully!");
        setUploadFileModal(!uploadFileModal);
        if (
          resp &&
          resp?.payload?.[0]?.documentLabelType &&
          resp?.payload?.[0]?.documentLabelType == "REFERRAL LETTER"
        )
          setCapfReferral([
            {
              documentType: resp?.payload?.[0]?.documentType,
              documentName: resp?.payload?.[0]?.documentName,
              documentUrl: resp?.payload?.[0]?.documentUrl,
              documentLabelType: resp?.payload?.[0]?.documentLabelType,
              id: resp?.payload?.[0]?.id,
            },
          ]);

        setActualReferralList((prevState: any) => {
          return [
            ...prevState,
            {
              documentType: resp?.payload?.[0]?.documentType,
              documentName: resp?.payload?.[0]?.documentName,
              documentUrl: resp?.payload?.[0]?.documentUrl,
              documentLabelType: resp?.payload?.[0]?.documentLabelType,
              id: resp?.payload?.[0]?.id,
            },
          ];
        });
        setSelectedReferral({
          documentType: resp?.payload?.[0]?.documentType,
          documentName: resp?.payload?.[0]?.documentName,
          documentUrl: resp?.payload?.[0]?.documentUrl,
          documentLabelType: resp?.payload?.[0]?.documentLabelType,
          id: resp?.payload?.[0]?.id,
        });

        setlistOfResponseUrl([
          ...(listOfResponseUrl ?? []),
          {
            documentType: resp?.payload?.[0]?.documentType,
            documentName: resp?.payload?.[0]?.documentName,
            documentUrl: resp?.payload?.[0]?.documentUrl,
            documentLabelType: resp?.payload?.[0]?.documentLabelType,
            id: resp?.payload?.[0]?.id,
          },
        ]);

        setNewDocumentTypes(
          newDocumentTypes?.filter(
            (item: any) => item?.label !== "REFERRAL LETTER",
          ),
        );
      }
    }
  };

  useEffect(() => {
    if (hospital?.selectedHospital?.value) {
      dispatch(
        fetchAllSchemesOnBoard({
          accessToken: auth.accessToken || "",
          healthCareId: hospital?.selectedHospital?.value,
        }),
      );
    }
  }, [hospital?.selectedHospital?.value]);

  // useEffect(() => {
  //   if (patients?.documentDetails?.documentType) {
  //     setUploadFileModal(false);
  //   }
  //   if (listOfResponseUrl && patients?.documentDetails?.documentType ) {
  //     setlistOfResponseUrl([
  //       ...listOfResponseUrl,
  //       {
  //         documentType: patients?.documentDetails?.documentType,
  //         documentName: patients?.documentDetails?.documentName,
  //         documentUrl: patients?.documentDetails?.documentUrl,
  //       },
  //     ]);
  //   } else {
  //     if (patients?.documentDetails?.documentType) {
  //       setlistOfResponseUrl([
  //         {
  //           documentType: patients?.documentDetails?.documentType,
  //           documentName: patients?.documentDetails?.documentName,
  //           documentUrl: patients?.documentDetails?.documentUrl,
  //         },
  //       ]);
  //     }
  //   }
  // }, [patients?.documentDetails]);

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields,
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  const handleSubmitPatient = async (values: any) => {
    let patientSchemeDetails;
    if (scheme?.selectedScheme) {
      patientSchemeDetails = {
        schemeMetaDataId: parseInt(scheme?.selectedScheme.split("-")[0]),
        identityNumber: values?.identityNumber,
        patientName: values?.fullName,
        portalMetaDataId: parseInt(scheme.selectedScheme.split("-")[3]),
        status: "ACTIVE",
        gsProviderId: parseInt(scheme?.selectedScheme.split("-")[0]),
        documentId: null,
        policyType: patients?.patientDetails?.policyType,
        policyEndDate: patients?.patientDetails?.policyEndDate
          ? dayjs(
              patients?.patientDetails?.policyEndDate,
              "DD-MM-YYYY HH:mm:ss",
            ).format("DD-MM-YYYY HH:mm:ss")
          : null,
        policySource: patients?.patientDetails?.policySource,
        employeeId: patients?.patientDetails?.employeeId,
        policyStartDate: patients?.patientDetails?.policyStartDate
          ? dayjs(
              patients?.patientDetails?.policyStartDate,
              "DD-MM-YYYY HH:mm:ss",
            ).format("DD-MM-YYYY HH:mm:ss")
          : null,
        derivedGroupPolicy:
          patients?.patientDetails?.derivedGroupPolicy || false,
        policyNumber: patients?.patientDetails?.policyNumber || "",
      };
    }

    const cardDoc =
      listOfResponseUrl?.find((doc) => {
        const label = (doc?.documentLabelType ?? "").toUpperCase();
        return ["CGHS CARD", "CAPF CARD"].includes(label);
      }) ||
      listOfResponseUrl?.find((doc) => {
        const label = (doc?.documentLabelType ?? "").toUpperCase();
        return label.includes("CARD");
      });

    const patientDocument = cardDoc
      ? {
          documentType: cardDoc.documentType || "",
          documentName: cardDoc.documentName || "",
          documentUrl: cardDoc.documentUrl || "",
          id: cardDoc.id || null,
        }
      : null;

    const formData = {
      patientRequest: {
        ...values,
        hospitalId: hospital?.selectedHospital?.value,
        patientDocument,
        patientSchemeDetails,
        pwaRegister: true
      },
      caseRequestNew: {
        caseTypeMetaDataId: values?.caseTypes?.split("~")[0],
      },
      visitInfoRequest: {
        // ...values,
        doa: values?.doa,
        dod: values?.dod,
        visitType: values?.caseTypes
          ?.split("~")[1]
          ?.toUpperCase()
          ?.includes("EMERGENCY")
          ? "EMERGENCY"
          : values?.caseTypes?.split("~")[1]?.toUpperCase()?.includes("OP") ||
              values?.caseTypes
                ?.split("~")[1]
                ?.toUpperCase()
                ?.includes("DIALYSIS")
            ? "OP"
            : "IP",
        status: true,
        pwaRegister: true
      },
    };

    const resp: any = await dispatch(
      postPatientDetails({
        formValues: formData,
        accessToken: auth.accessToken || "",
      }),
    );

    if (postPatientDetails.fulfilled.match(resp)) {
      if (scheme?.selectedScheme) {
        // navigate(
        //   `/app/visit-details/${resp?.payload?.patient?.visitInfoResponse?.id}`,
        // );
        setIsSubmit(false);
        setIsModalOpen(false);
        if(scheme?.selectedScheme?.toLowerCase()?.includes("echs")) {
          handleGenerateClaimId(values, resp);
        }
        else if(scheme?.selectedScheme?.toLowerCase()?.includes("cghs") || scheme?.selectedScheme?.toLowerCase()?.includes("capf new")) {
          // handlePortalRegistration(values, resp);
          navigate(`/app/portal-registration/${resp?.payload?.patient?.visitInfoResponse?.id}`);
        }
      } else {
        setIsConfirmationModal(true);
      }

      if (resp?.payload?.patient?.message) {
        successMessage(resp?.payload?.patient?.message);
        setIsModalOpen(false);
        setIsSubmit(true);
        setFormValues(values);
        setlistOfResponseUrl(null);
        dispatch(clearOcrDetails());
        dispatch(clearOcrDetailsOfReferral());
      } else if (resp?.payload?.status == 208 || resp?.payload?.errorMessage) {
        errorMessage(resp?.payload?.errorMessage || "");
        setIsSubmit(true);
        setFormValues(values);
        setlistOfResponseUrl(null);
        dispatch(clearOcrDetails());
        dispatch(clearOcrDetailsOfReferral());
        setIsModalOpen(false);
      }
    } else if (postPatientDetails.rejected.match(resp)) {
      setIsModalOpen(false);
      errorMessage(resp?.error?.message || "Please, Try Again after sometime");
    }
  };

  const addScheme = async () => {
    if (
      scheme?.selectedScheme &&
      scheme.selectedScheme?.length > 0 &&
      formValues?.identityNumber
    ) {
      const resp = await dispatch(
        addPatientScheme({
          formData: {
            schemePolicyNumber: formValues?.identityNumber,
            status: "ACTIVE",
          },
          accessToken: auth.accessToken || "",
          patientId: patients?.patientDetails?.id,
          schemeId: parseInt(scheme.selectedScheme?.split("-")[0]),
        }),
      );

      if (addPatientScheme.fulfilled.match(resp)) {
        // successMessage("Scheme has been added");
      } else if (addPatientScheme.rejected.match(resp)) {
        errorMessage("Scheme failed to be Added");
      }
      navigate(`/app/patient-details/${patients?.patientDetails?.id}`);
      setIsSubmit(false);
    } else {
      setIsConfirmationModal(true);
    }
  };

  useEffect(() => {
    if (patients?.patientDetails?.id) {
      if (scheme?.selectedScheme && scheme.selectedScheme?.length > 0) {
        // addScheme();
      } else {
        setIsConfirmationModal(true);
      }
    }
  }, [
    auth.accessToken,
    dispatch,
    formValues?.identityNumber,
    isSubmit,
    navigate,
    patients?.patientDetails?.id,
    scheme.selectedScheme,
  ]);

  // useEffect(() => {
  //   if (patients?.patientDetails?.id && !isClicked) {
  //     setOpenModal(true);
  //   }
  // }, [isClicked, patients?.patientDetails]);

  const secondaryMobileChange = (checked: boolean) => {
    setSecondaryMobileOnWhatsApp(checked);
  };

  const primaryMobileChange = (checked: boolean) => {
    setPrimaryMobileOnWhatsApp(checked);
  };

  const handleCancel = () => {
    setOpenModal(false);
    setIsClicked(true);
    navigate(`/app/patient-details/${patients?.patientDetails?.id}`);
  };

  const handleConfirm = () => {
    setOpenModal(false);
    setIsClicked(true);
    navigate({
      pathname: `${ROUTES.ADD_PATIENT_SCHEME}/${patients?.patientDetails?.id}`,
    });
  };

  const [justify, setJustify] = useState<string>("");

  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 1200) {
      // adjust the value as per your requirement
      setJustify("space-evenly");
    } else {
      setJustify("space-between");
    }
  };

  useEffect(() => {
    handleResize(); // set the initial value
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    //to clear redux
    setOpenModal(false);
    dispatch(clearPatientDetails());
    dispatch(clearSelectedScheme());
  }, [dispatch]);

  const extractTextBeforePlus = (identityNumberLabel: string) => {
    const pattern = /^(.*?)\s*\+\s*.*$/;
    const match = identityNumberLabel.match(pattern);
    if (match) {
      return match[1].trim();
    } else {
      return null;
    }
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  const handleDeleteList = async (deleteDocument: any, docType: string) => {
    console.log("deleteDocument", deleteDocument, docType);
    if (deleteDocument?.documentLabelType == "REFERRAL LETTER") {
      const list = actualReferralList?.filter(
        (item: any) => item.id !== deleteDocument?.id,
      );
      setActualReferralList(list);
      const reamianingData = listOfUploadDocData?.filter(
        (item: any) => item.id !== deleteDocument?.id,
      );
      setListOfUploadDocData(reamianingData);
      setIsReferralUploaded(false);
      if (deleteDocument?.documentType == patients?.ocrDetails?.documentType) {
        dispatch(clearOcrDetails());
        dispatch(clearOcrDetailsOfReferral());
      }
    } else {
      if (docType == "referral") {
        const list = actualReferralList?.filter(
          (item: any) => item.id !== deleteDocument?.id,
        );
        setActualReferralList(list);
      } else if (docType?.toLowerCase()?.includes("index")) {
        const listOfActualCards = actualIndexCardList?.filter(
          (item: any) => item.id !== deleteDocument?.id,
        );
        setActualIndexCardList(listOfActualCards);
        setIndexCardSavedPatient(null);
      } else if (docType?.toLowerCase()?.includes("regn slip")) {
        const listOfActualRegnSlips = actualRegnSlipList?.filter(
          (item: any) => item.id !== deleteDocument?.id,
        );
        setActualRegnSlipList(listOfActualRegnSlips);
        setRegistrationSlipSavedPatient(null);
      } else if (docType == "cards") {
        const listOfActualCards = actualCardList?.filter(
          (item: any) => item.id !== deleteDocument?.id,
        );
        setActualCardList(listOfActualCards);
      }

      const reamianingData = listOfUploadDocData?.filter(
        (item: any) => item.id !== deleteDocument?.id,
      );

      setListOfUploadDocData(reamianingData);

      const deleteForm = {
        documentUrl: deleteDocument?.documentUrl,
        status: false,
        id: deleteDocument?.id,
      };

      if (deleteDocument?.documentUrl) {
        try {
          await dispatch(deleteUploadedDocument(deleteForm));
        } catch (err) {
          console.error(err);
        }
      }
      setResetForm(true);
      dispatch(clearPatientDetails());
    }
    setShowCompareModal(false);
    setIsDisabled(false);
    if (deleteDocument?.documentType == patients?.ocrDetails?.documentType) {
      dispatch(clearOcrDetails());
      dispatch(clearOcrDetailsOfReferral());
    }
  };

  const getFileType = (url: any) => {
    const extension = url.split(".").pop().toLowerCase(); // Get file extension
    if (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "gif"
    ) {
      return "image";
    } else if (extension === "pdf") {
      return "pdf";
    } else {
      return "unknown";
    }
  };

  const handleShowConfirmPopUp = (values: any) => {
    setSubmittedPatientDetails(values);
    setIsModalOpen(!isModalOpen);
  };

  const handleOkConfirmationModal = () => {
    handleSubmitPatient(submittedPatientDetails);
  };

  const handleCancelConfirmationModal = () => {
    setOpen(false);
    setIsModalOpen(!isModalOpen);
  };

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 0.5));
  };

  const handleDoctorSearch = async (value: string) => {
    if (value) {
      dispatch(
        getDoctors({
          search: value,
          accessToken: auth.accessToken || "",
          hospitalId: hospital?.selectedHospital?.value,
        }),
      );
    }
  };

  const clearDoctorList = () => {
    dispatch(resetAvailableDoctors());
  };

  useEffect(() => {
    if (selectedSchemeId != "null" && selectedSchemeId) {
      dispatch(
        getCaseTypes({
          accessToken: auth.accessToken || "",
          schemeId: parseInt(selectedSchemeId),
        }),
      );
    }
  }, [selectedSchemeId]);

  const handleSearchPatient = async (value: string, type: string) => {
    if (type == "uhid") {
      setlistOfResponseUrl(null);
    }
    setListOfUploadDocData([]);
    setActualReferralList([]);
    setActualCardList([]);
    setActualIndexCardList([]);
    setActualRegnSlipList([]);
    setSelectedReferral(null);

    const formData = {
      uhidNo: type === "uhid" ? value : null,
      beneficiaryNo: type === "beneficiary" ? value : null,
      uhidNoPresent: type === "uhid" ? true : false,
      healthCareId: hospital?.selectedHospital?.value,
    };
    if (value && scheme?.selectedScheme) {
      const resp = await dispatch(
        getPatientDetailsUsingUHID({
          formData: formData,
          schemeMetaDataId: parseInt(scheme.selectedScheme.split("-")[0]),
        }),
      );
      if (getPatientDetailsUsingUHID.fulfilled.match(resp)) {
        if (type == "uhid") {
          setIsConfirmCardModal(false);
        }
        setShowPatientFields(false);
        setIsUploadCardAndReferral("");
      } else if (getPatientDetailsUsingUHID.rejected.match(resp)) {
        if (
          type == "uhid" &&
          !scheme?.selectedScheme?.toLowerCase()?.includes("echs")
        ) {
          setIsConfirmCardModal(true);
          setIsUploadCardAndReferral("");
        } else if (
          type == "uhid" &&
          scheme?.selectedScheme?.toLowerCase()?.includes("echs")
        ) {
          setIsUploadCardAndReferral("YES");
        }
        setShowPatientFields(false);
      }
    }
  };

  useEffect(() => {
    if (selectedReferralId) {
      dispatch(getReferralById(selectedReferralId));
    }
  }, [selectedReferralId]);

  const handleReferralChange = (referralValue: any) => {
    if (!referralValue?.referenceType) {
      setSelectedReferralId(null);
      dispatch(swapReadOcrDetails(patients?.ocrDetailsOfReferral));
    } else if (
      referralValue?.documentLabelType?.toLowerCase()?.includes("referral")
    ) {
      dispatch(clearOcrDetails());
      dispatch(clearOcrDetailsOfReferral());
      setSelectedReferralId(referralValue?.id);
    }
    setIsReferralUploaded(true);
  };

  useEffect(() => {
    if (referral?.referralData) {
      const newDocument = {
        documentType: referral?.referralData?.documentType,
        documentName: referral?.referralData?.documentName,
        documentUrl: referral?.referralData?.documentUrl,
        documentLabelType: referral?.referralData?.documentLabelType,
        id: referral?.referralData?.documentId,
      };

      if (newDocument?.documentLabelType) {
        setlistOfResponseUrl((prevList) => {
          const existingIndex = prevList
            ? prevList?.findIndex(
                (doc) => doc?.documentType === newDocument?.documentType,
              )
            : -1;

          if (existingIndex !== -1 && prevList) {
            const updatedList = [...prevList];
            updatedList[existingIndex] = newDocument;
            return updatedList;
          } else {
            return prevList ? [...prevList, newDocument] : [newDocument];
          }
        });
      }
    } else {
      setlistOfResponseUrl(null);

      // const newList = listOfResponseUrl?.filter((doc) => !doc?.documentLabelType?.toLowerCase()?.includes("referral"));

      // if(newList?.length === 0) {
      //   setlistOfResponseUrl(null);
      // }
      // else if(newList && newList?.length > 0) setlistOfResponseUrl(newList);
    }
  }, [referral?.referralData]);

  const [activeKey, setActiveKey] = useState<string | null>(null);

  const handleAddPatientManually = () => {
    setShowPatientFields(true);
  };

  useEffect(() => {
    if (scheme?.schemeOnBoarding?.length === 1) {
      dispatch(
        selectedScheme(
          scheme?.schemeOnBoarding?.[0]?.schemeMetaDataId +
            "-" +
            scheme?.schemeOnBoarding?.[0]?.schemeMetaDataName +
            "-" +
            scheme?.schemeOnBoarding?.[0]?.schemePersonalIdentifierLabelName +
            "-" +
            scheme?.schemeOnBoarding?.[0]?.portalMetaDataIdsList?.[0] +
            "-" +
            scheme?.schemeOnBoarding?.[0]?.schemeType,
        ),
      );
      setSelectedSchemeId(
        scheme?.schemeOnBoarding?.[0]?.schemeMetaDataId?.toString(),
      );
      setActiveKey(
        scheme?.schemeOnBoarding?.[0]?.schemeMetaDataId +
          "-" +
          scheme?.schemeOnBoarding?.[0]?.schemeMetaDataName +
          "-" +
          scheme?.schemeOnBoarding?.[0]?.schemePersonalIdentifierLabelName +
          "-" +
          scheme?.schemeOnBoarding?.[0]?.portalMetaDataIdsList?.[0] +
          "-" +
          scheme?.schemeOnBoarding?.[0]?.schemeType,
      );
      setIsSchemeSelected(true);
    }
  }, [scheme?.schemeOnBoarding]);

  const [isUploadCardAndReferral, setIsUploadCardAndReferral] = useState("YES");
  const handleCancelConfirmDoc = () => {
    setShowPatientFields(true);
    setIsUploadCardAndReferral("NO");
    setIsConfirmCardModal(!isConfirmCardModal);
  };
  const handleOkConfirmDoc = () => {
    setShowPatientFields(false);
    setIsUploadCardAndReferral("YES");
    setIsConfirmCardModal(!isConfirmCardModal);
  };

  useEffect(() => {
    if (scheme?.selectedScheme?.toLowerCase()?.includes("echs")) {
      setShowPatientFields(false);
      setIsUploadCardAndReferral("YES");
      // setIsConfirmCardModal(!isConfirmCardModal);
    }
  }, [scheme?.selectedScheme]);

  const schemeTabs: any = scheme.schemeOnBoarding?.reduce<any>(
    (acc: any, schemePresent: any) => {
      const name = schemePresent?.schemeMetaDataName?.toLowerCase();
      const isGovt = schemePresent?.schemeType?.toLowerCase()?.includes("govt");
      // if (["cghs", "echs", "capf", "pmjy", "ayushman bharat"].includes(name)) {
      //   acc.tabs.push(schemePresent);
      // } else {
      //   acc.dropdown.push(schemePresent);
      // }
      if (isGovt) {
        acc.tabs.push(schemePresent);
      } else {
        acc.dropdown.push(schemePresent);
      }
      return acc;
    },
    { tabs: [], dropdown: [] },
  );

  const isTPAPresent = schemeTabs.tabs?.some(
    (tab: any) => tab.schemeMetaDataName?.toLowerCase() === "tpa",
  );

  if (!isTPAPresent && schemeTabs.dropdown?.length > 0) {
    schemeTabs.tabs.push({
      schemeMetaDataName: "TPA",
      schemeMetaDataId: null,
      schemePersonalIdentifierLabelName: null,
      portalMetaDataIdsList: null,
    });
  }

  //index card modal
  const handleSave = (selectedId: any) => {
    const selected = indexCardPatients?.find(
      (item: any) => item.benId === selectedId,
    );
    if (selected) {
      setIndexCardSavedPatient(selected);
    }
    setIndexCardPatients([]);
    setIndexCardModal(false);
  };

  //regn slip modal
  const handleSaveRegnSlip = (selectedId: any) => {
    const selected = registrationSlipPatients?.find(
      (item: any) => item.name + "~" + item.dob === selectedId,
    );
    if (selected) {
      setRegistrationSlipSavedPatient(selected);
      setShowPatientFields(true);
    }
    setRegistrationSlipPatients([]);
    setRegistrationSlipModal(false);
  };

  const clinicalConditions = [
    {
      key: "bp",
      label: "BLOOD PRESSURE",
      valuePrefix: "1",
    },
    {
      key: "cvs",
      label: "CARDIOVASCULAR SYSTEM",
      valuePrefix: "2",
    },
    {
      key: "rs",
      label: "RESPIRATORY SYSTEM",
      valuePrefix: "3",
    },
    {
      key: "abdomen",
      label: "ABDOMEN",
      valuePrefix: "4",
    },
    {
      key: "cns",
      label: "CENTRAL NERVOUS SYSTEM",
      valuePrefix: "5",
    },
    {
      key: "covid",
      label: "COVID",
      valuePrefix: "6",
    },
    {
      key: "clinicalOther",
      label: "OTHER",
      valuePrefix: "99",
    },
  ];

  const treatmentConditions = [
    {
      key: "investigations",
      label: "INVESTIGATIONS",
      valuePrefix: "1",
    },
    {
      key: "intensiveCare",
      label: "INTENSIVE CARE",
      valuePrefix: "2",
    },
    {
      key: "medicalManagement",
      label: "MEDICAL MANAGEMENT",
      valuePrefix: "3",
    },
    {
      key: "surgicalManagement",
      label: "SURGICAL MANAGEMENT",
      valuePrefix: "4",
    },
    {
      key: "minorDescription",
      label: "PROCEDURE MINOR DESCRIPTION",
      valuePrefix: "5",
    },
    {
      key: "majorDescription",
      label: "PROCEDURE MAJOR DESCRIPTION",
      valuePrefix: "6",
    },
    {
      key: "proposedOther",
      label: "PROPOSED OTHER",
      valuePrefix: "99",
    },
  ];

  const medicalConditions = [
    {
      key: "hypertension",
      label: "HYPERTENSION",
      valuePrefix: "1",
    },
    {
      key: "diabetic",
      label: "DIABETIC",
      valuePrefix: "2",
    },
    {
      key: "heart",
      label: "HEART",
      valuePrefix: "3",
    },
    {
      key: "copd",
      label: "CHRONIC OBSTRUCTIVE PULMONARY DISEASE (COPD)",
      valuePrefix: "4",
    },
    {
      key: "asthma",
      label: "BRONCHIAL ASTHMA",
      valuePrefix: "5",
    },
    {
      key: "std",
      label: "SEXUALLY TRANSMITTED DISEASE (STD)",
      valuePrefix: "6",
    },
    {
      key: "alcohol",
      label: "ALCOHOL/DRUGS INTOXICATION",
      valuePrefix: "7",
    },
    {
      key: "other",
      label: "OTHER DISEASE",
      valuePrefix: "99",
    },
  ];

  const createReferralAcceptanceOnlyPayload = (values: any) => {
    // Process medical history data
    const patientMedicalHistoryData = medicalConditions?.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );

    const updatedPatientMedicalHistory = medicalConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        const inputValue =
          values?.patientMedicalHistory?.[`${condition.key}Value`] || null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );

    const patientClinicalFindingsData = clinicalConditions.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );
    // Process clinical findings data
    const updatedPatientClinicalFindings = clinicalConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        if (condition.key === "bp") {
          acc[condition.key] = `${baseValue}:Y:130/90`;
          return acc;
        }
        const inputValue =
          values?.patientClinicalFindings?.[`${condition.key}Value`] || null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );

    const patientProposedTreatmentData = treatmentConditions?.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );
    // Process treatment data
    const updatedPatientProposedTreatmentData = treatmentConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        if (condition.key === "medicalManagement") {
          acc[condition.key] = `${baseValue}:Y:supportive treatment`;
          return acc;
        }
        const inputValue =
          values?.patientProposedTreatmentData?.[`${condition.key}Value`] ||
          null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );
    return {
      schemeMetaDataId: scheme?.selectedScheme
        ? parseInt(scheme?.selectedScheme.split("-")[0])
        : null,
      portalMetaDataId: scheme?.selectedScheme
        ? parseInt(scheme.selectedScheme.split("-")[3])
        : null,
      casePreAuthId: 0,
      casePreAuthIhxRequest: null,
      casePreAuthCghsRequest: null,
      casePreAuthVidalRequest: null,
      casePreAuthStarhealthRequest: null,
      casePreAuthEchsRequest: {
        casePreAuthEchsReferralRequest: {
          casePreAuthRequest: {
            beneficiaryId: values?.identityNumber,
            patientOpdIpdNumber: values?.opNumber,
          },
          referralAcceptanceOnly: true,
          fromFo: auth?.role?.role === "FO_STAFF" ? true : false,
          casePreAuthEchsDiagnosisList: [],
          admissionType: values?.caseTypes?.split("~")?.[1]?.toUpperCase(),
          patientDetails: {
            aadharStatus: values?.aadharStatus || "",
            aadharNumber: values?.aadharNumber || "",
          },
          admissionData: {
            roomNumber: values?.cardCategory,
            opdDate: values?.doa
              ? dayjs(values.doa).format("DD-MM-YYYY HH:mm:ss")
              : null,
            expectedDischargeDate: values?.dod
              ? dayjs(values.dod).format("DD-MM-YYYY HH:mm:ss")
              : null,
            polyClinic: values?.referralInfoRequest?.echsReferralRequest?.polyClinic,
            remarks: values?.remarks || "Intimation Submitted",
            approxTreatmentCost:
              values?.caseTypes?.split("~")?.[1]?.toUpperCase() === "OP"
                ? null
                : 50000,
            roomType: values?.cardCategory,
          },

          patientMedicalHistory: updatedPatientMedicalHistory,
          patientClinicalFindings: updatedPatientClinicalFindings,
          patientProposedTreatmentData: updatedPatientProposedTreatmentData,
          referralId: values?.referralInfoRequest?.echsReferralRequest?.referralNo,
          serviceNumber: values?.referralInfoRequest?.echsReferralRequest?.serviceNumber,
          cardId: values?.referralInfoRequest?.echsReferralRequest?.cardNumber,
          opNumber: values?.opNumber,
          admissionDate: values?.doa
            ? dayjs(values.doa).format("DD-MM-YYYY HH:mm:ss")
            : null,
          type: "referral",
          followUpReferral: true,
          remarks: values?.remarks || "Intimation Submitted",
          listofResponseUrl: null,
          patientDocuments: null,
          patientDiagnosticData: {
            isRta: values?.isRta,
            admissionAilment: values?.admissionAilment,
            ailmentDuration: values?.ailmentDuration,
            rtaReason: values?.rtaReason,
            rtaDate: values?.rtaDate
              ? dayjs(values?.rtaDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss",
                )
              : null,
          },
        },

        echsPreAuthEmergencyRequest: null,
        hospitalId: hospital?.selectedHospital?.value,
        schemeId: scheme?.selectedScheme
          ? parseInt(scheme?.selectedScheme.split("-")[0])
          : null,
      },
      totalAmount: null,
      action: "save",
      referralAcceptanceOnly: true,
      fromFo: auth?.role?.role === "FO_STAFF" ? true : false,
    };
  };

  const createEmergencyAcceptancePayload = (values: any) => {
    const patientMedicalHistoryData = medicalConditions?.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );
    // Process medical history data
    const updatedPatientMedicalHistory = medicalConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        const inputValue =
          values?.patientMedicalHistory?.[`${condition.key}Value`] || null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );

    const patientClinicalFindingsData = clinicalConditions.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );

    const updatedPatientClinicalFindings = clinicalConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        if (condition.key === "bp") {
          acc[condition.key] = `${baseValue}:Y:130/90`;
          return acc;
        }
        const inputValue =
          values?.patientClinicalFindings?.[`${condition.key}Value`] || null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );

    const patientProposedTreatmentData = treatmentConditions.reduce(
      (acc, condition) => ({
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      }),
      {},
    );

    const updatedPatientProposedTreatmentData = treatmentConditions.reduce(
      (acc: any, condition) => {
        const baseValue = condition.valuePrefix;
        if (condition.key === "medicalManagement") {
          acc[condition.key] = `${baseValue}:Y:supportive treatment`;
          return acc;
        }
        const inputValue =
          values?.patientProposedTreatmentData?.[`${condition.key}Value`] ||
          null;

        acc[condition.key] = `${baseValue}:M:${inputValue}`;
        return acc;
      },
      {},
    );

    return {
      schemeMetaDataId: scheme?.selectedScheme
        ? parseInt(scheme?.selectedScheme.split("-")[0])
        : null,
      portalMetaDataId: scheme?.selectedScheme
        ? parseInt(scheme.selectedScheme.split("-")[3])
        : null,
      casePreAuthId: 0,
      casePreAuthIhxRequest: null,
      casePreAuthCghsRequest: null,
      casePreAuthVidalRequest: null,
      casePreAuthStarhealthRequest: null,
      casePreAuthEchsRequest: {
        casePreAuthEchsReferralRequest: null,
        echsPreAuthEmergencyRequest: {
          casePreAuthRequest: {
            beneficiaryId: values?.identityNumber,
            patientOpdIpdNumber: values?.opNumber,
          },
          referralAcceptanceOnly: true,
          fromFo: auth?.role?.role === "FO_STAFF" ? true : false,
          casePreAuthEchsDiagnosisList: [],
          admissionType: values?.caseTypes?.split("~")?.[1]?.toUpperCase(),
          patientDetails: {
            aadharStatus: values?.aadharStatus || "",
            aadharNumber: values?.aadharNumber || "",
          },
          admissionData: {
            ...values?.admissionData,
            roomNumber: values?.cardCategory,
            approxTreatmentCost:
              values?.caseTypes?.split("~")?.[1]?.toUpperCase() === "OP"
                ? null
                : 50000,
            opdDate: values?.doa
              ? dayjs(values.doa).format("DD-MM-YYYY HH:mm:ss")
              : null,
            expectedDischargeDate: values?.dod
              ? dayjs(values.dod).format("DD-MM-YYYY HH:mm:ss")
              : null,
            polyClinic: values?.referralInfoRequest?.echsReferralRequest?.polyClinic,
            remarks: "Intimation Submitted",
            roomType: values?.cardCategory,
          },
          polyclinicName:
            values?.polyclinicName || values?.referralInfoRequest?.echsReferralRequest?.polyClinic,
          patientMedicalHistory: updatedPatientMedicalHistory,
          patientClinicalFindings: updatedPatientClinicalFindings,
          patientProposedTreatmentData: updatedPatientProposedTreatmentData,
          serviceNumber: values?.referralInfoRequest?.echsReferralRequest?.serviceNumber,
          opNumber: values?.opNumber,
          admissionDate: values?.doa
            ? dayjs(values.doa).format("DD-MM-YYYY HH:mm:ss")
            : null,
          type: "emergency",
          remarks: values?.remarks || "Intimation Submitted",
          portal: "echs",
          gsproviderId: 1,
          patientDocuments: null,
          listofResponseUrl: null,
          patientDiagnosticData: {
            isRta: values?.isRta,
            admissionAilment: values?.admissionAilment,
            ailmentDuration: values?.ailmentDuration,
            rtaReason: values?.rtaReason,
            rtaDate: values?.rtaDate
              ? dayjs(values?.rtaDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss",
                )
              : null,
          },
        },
        hospitalId: hospital?.selectedHospital?.value,
        schemeId: scheme?.selectedScheme
          ? parseInt(scheme?.selectedScheme.split("-")[0])
          : null,
      },
      totalAmount: null,
      action: "save",
      referralAcceptanceOnly: true,
      fromFo: auth?.role?.role === "FO_STAFF" ? true : false,
    };
  };

  const handleGenerateClaimId = async (values: any, resp: any) => {
    try {
      const visitTypeUpper = values?.caseTypes?.split("~")?.[1]?.toUpperCase();
      const isEmergencyCase =
        visitTypeUpper === "EMERGENCY" || !isReferralUploaded;
      const formData = isEmergencyCase
        ? createEmergencyAcceptancePayload(values)
        : createReferralAcceptanceOnlyPayload(values);

      if (scheme?.selectedScheme) {
        const res = await saveDraftEchs(
          resp?.payload?.patient?.casesResponse?.id,
          resp?.payload?.patient?.visitInfoResponse?.id,
          {
            ...formData,
            action: "intimate",
            referralAcceptanceOnly: true,
            fromFo: auth?.role?.role === "FO_STAFF" ? true : false,
            integratedWithPortal: true,
            casePreAuthEchsRequest: {
              ...formData?.casePreAuthEchsRequest,
              manualPreAuth: false,
              sendToPortal: true,
            },
          },
        );

        if (res) {
          navigate(
          `/app/claim-id-generation/${resp?.payload?.patient?.visitInfoResponse?.id}`,
        );
          // successMessage("Claim Id Sent For Generation Successfully");
        }
      }
    } catch (err: any) {
      errorMessage("Please, Try again later");
    } finally {
    }
  };

  const handlePortalRegistration = async (values: any, resp: any) => {
    try {
      if (resp?.payload?.patient?.casesResponse?.schemeMetaDataId) {
        const updatedData = {
          beneficiaryId: values?.identityNumber,
          registrationDate: values?.registrationDate
            ? values?.registrationDate
            : null,
          manualRegistration: true,
          schemeRegistrationId: values?.registrationId,
          caseId: resp?.payload?.patient?.casesResponse?.id,
          visitId: resp?.payload?.patient?.visitInfoResponse?.id,
          isCghs:
            resp?.payload?.patient?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS NEW"
              ? true
              : false,
          hospitalId: resp?.payload?.patient?.casesResponse?.healthCareId,
          schemeId:
            resp?.payload?.patient?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            resp?.payload?.patient?.casesResponse?.integratedWithPortal,
        };

        const res = await registerPatientPortalCghsNew(
          resp?.payload?.patient?.casesResponse?.portalMetaDataIds?.[0],
          updatedData,
        );
        if (res) {
          navigate(
          `/app/claim-id-generation/${resp?.payload?.patient?.visitInfoResponse?.id}`,
        );
        // successMessage("Registered Successfully");
      }
      }
    }
    catch(err) {
      errorMessage("Please, Try again later");
    }
  }

  const addPatientProps = {
    documentTypes,
    documentType,
    setDocumentType,
    selectedFile,
    listOfResponseUrl,
    uploadFileModal,
    setUploadFileModal,
    handleSelectChange,
    handleFileChange,
    viewFile,
    handleSaveReferral,
    patientDetails: patients?.patientDetails,
    schemeData: scheme.schemeOnBoarding,
    handleSchemeChange,
    schemeSelected: scheme.selectedScheme,
    handleSubmitPatient,
    calculateAge,
    secondaryMobileOnWhatsApp,
    primaryMobileOnWhatsApp,
    secondaryMobileChange,
    primaryMobileChange,
    open: openModal,
    handleCancel,
    handleConfirm,
    extractTextBeforePlus,
    handleGetPatientFromPortal,
    isConfirmationModal,
    isLoading: patients?.isLoading,
    isFetchingPatientDetails: patients?.isFetchingPatientDetails,
    isPostPatientDetails: patients?.isPostPatientDetails,
    justify,
    handleDownloadDocument,
    isDownloadingDocument,
    downloadingDocumentUrl,
    handleDeleteList,
    isReferralLoading: patients?.isLoading,
    showCompareModal,
    handleShowConfirmModal,
    handleShowConfirmModal2,
    getFileType,
    handleZoomIn,
    handleZoomOut,
    zoomLevel,
    ocrDetails: patients?.ocrDetails,
    handleShowServices,
    showServices,
    previewDocumentUrl,
    isSchemeSelected,
    resetForm,
    handleDeficiencyModal: handleDeficiencyModalOpen,
    closeDeficiencyModal,
    deficiencyModal,
    deficiencyQuestions: patients?.deficiencyCheckQuestions,
    selectedDocument,
    availableDoctor: doctorOptions,
    handleDoctorSearch,
    clearDoctorList,
    totalCases: cases?.caseType || [],
    handleSearchPatient,
    referralList: Object.values(patients?.referrals),
    handleReferralChange,
    referralData: referral?.referralData,
    error: patients?.error,
    isModalOpen,
    setIsModalOpen,
    handleOk: handleOkConfirmationModal,
    handleShowConfirmPopUp,
    handleCancelConfirmationModal,
    showPatientFields,
    handleAddPatientManually,
    handleUploadCapfReferral,
    uhidNo: patients?.uhidNo,
    isConfirmCardModal,
    setIsConfirmCardModal,
    handleCancelConfirmDoc,
    handleOkConfirmDoc,
    selectedReferralId,
    actualReferralList,
    actualCardList,
    actualIndexCardList,
    actualRegnSlipList,
    isUploadCardAndReferral,
    listOfUploadDocData,
    isReferralUploaded,
    setIsReferralUploaded,
    setActualCardList,
    setActualIndexCardList,
    capfreferal,
    setNewDocumentTypes,
    newDocumentTypes,
    setActualReferralList,
    setSelectedReferral,
    selectedReferral,
    indexCardSavedPatient,
    indexCardCategory,
    selectedCaseType: selectedCaseTypeName,
    isDisabled,
    registrationSlipSavedPatient,
    registrationSlipCategory,
    isFetchingDocuments
  };

  const allSchemes = [
    ...(schemeTabs?.tabs || []),
    ...(schemeTabs?.dropdown || []),
  ];

  return (
    <Spin spinning={scheme?.isFetchingScheme} size="small">
    <div className="add-patient-container">
      {/* <div className="flex-header">
        <Title level={5} className="patient-registration-title">
          CLAIM ID GENERATION
        </Title>
      </div> */}

      {/* SCHEME SELECTION SECTION */}
      {/* <div className="scheme-section"> */}
        {/* <Tabs
          activeKey={scheme?.selectedScheme || ""}
          onChange={handleSchemeChange}
          type="card"
          size="large"
          tabBarGutter={12}
          className="custom-tabs"
          // tabBarStyle={{ overflowX: "auto" }}
        >
          {allSchemes
            ?.filter(
              (s) =>
                s.schemeMetaDataName === "CGHS NEW" || s.schemeMetaDataName === "ECHS",
            )
            ?.map((s) => {
              const value = `${s.schemeMetaDataId}-${s.schemeMetaDataName}-${s.schemePersonalIdentifierLabelName}-${s.portalMetaDataIdsList?.[0]}-${s.schemeType}`;
              return <Tabs.TabPane tab={s.schemeMetaDataName} key={value} />;
            })}
        </Tabs> */}
        <Radio.Group
          value={scheme?.selectedScheme || ""}
          onChange={handleSchemeChange}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
          className="custom-radio"
        >
          {allSchemes
            ?.filter((s: any) =>
              ["CGHS NEW", "ECHS", "CAPF NEW"].includes(s?.schemeMetaDataName),
            )
            ?.map((s: any) => (
              <Radio key={s.schemeMetaDataId} value={`${s.schemeMetaDataId}-${s.schemeMetaDataName}-${s.schemePersonalIdentifierLabelName}-${s.portalMetaDataIdsList?.[0]}-${s.schemeType}`}>
                {s.schemeMetaDataName}
              </Radio>
            ))}
        </Radio.Group>
      {/* </div> */}

      {/* FORM CONTENT */}
      {scheme?.selectedScheme && (
        <div 
        // className="form-container" 
        style={{ width: "100%" }}>
          {/* some top spacing retained, header removed for cleaner UI */}
          <div style={{ marginBottom: "0.6rem" }} />

          {(scheme.selectedScheme.toLowerCase().includes("govt") ? (
            scheme.selectedScheme.toLowerCase().includes("ayushman bharat") ? (
              <>
                <Row gutter={[8, 8]}>
                  <Col span={24}>
                    <Form.Item
                      label="Case Type"
                      name="caseType"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Case Type"
                        onChange={setSelectedCaseTypeName}
                        options={cases?.caseType?.map((ct) => ({
                          label: ct.name,
                          value: `${ct.id}~${ct.name}`,
                        }))}
                        style={{ fontSize: "0.95rem" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {!selectedCaseTypeName?.toLowerCase()?.includes("dialysis") && (
                  <AddNewPatientForm {...addPatientProps} />
                )}
              </>
            ) : (
              <AddNewPatientForm {...addPatientProps} />
            )
          ) : (
            <AddNewPatientForm {...addPatientProps} />
          ))}
          </div>
      )}
      

      {/* MODALS (UNCHANGED) */}
      <IndexLetterModal
        isModalOpen={indexCardModal}
        handleSave={handleSave}
        handleCancel={() => setIndexCardModal(false)}
        indexCardPatients={indexCardPatients}
      />

      <RegistrationSlipModal
        isModalOpen={registrationSlipModal}
        handleSave={handleSaveRegnSlip}
        handleCancel={() => setRegistrationSlipModal(false)}
        registrationSlipPatients={registrationSlipPatients}
      />

      <RejectionModal
        open={isVerifyPatientModal}
        title="Beneficiary Id from Referral and Card is not matching. Do you want to proceed?"
        handleCancel={() => {
          setIsDisabled(true);
          setIsVerifyPatientModal(false);
        }}
        handleSave={() => {
          setIsDisabled(false);
          setIsVerifyPatientModal(false);
        }}
      />
    </div>
    </Spin>
  );
};

export default AddPatientContainer;
